import { useLayoutEffect } from "react";

// The browser/OS paints the gesture area from document colors, outside the shell.
// Use the same surface as the mobile bottom menu, without adding screen space.
export const BROWSER_THEME_COLORS = { light: "#fffdf8", dark: "#181b30" };

export default function useBrowserTheme(isDark) {
  useLayoutEffect(() => {
    const scheme = isDark ? "dark" : "light";
    const color = BROWSER_THEME_COLORS[scheme];
    const restore = [];

    for (const element of [document.documentElement, document.body]) {
      for (const [property, value] of [["background-color", color], ["color-scheme", scheme]]) {
        const previous = element.style.getPropertyValue(property);
        const priority = element.style.getPropertyPriority(property);
        element.style.setProperty(property, value, "important");
        restore.push(() => {
          if (previous) element.style.setProperty(property, previous, priority);
          else element.style.removeProperty(property);
        });
      }
    }

    for (const [name, content] of [["theme-color", color], ["color-scheme", scheme]]) {
      let meta = document.head.querySelector(`meta[name="${name}"]`);
      const created = !meta;
      if (created) {
        meta = document.createElement("meta");
        meta.name = name;
        document.head.appendChild(meta);
      }
      const previous = meta.getAttribute("content");
      meta.setAttribute("content", content);
      restore.push(() => {
        if (created) meta.remove();
        else if (previous === null) meta.removeAttribute("content");
        else meta.setAttribute("content", previous);
      });
    }

    // Leave public pages and other application roots with their own document theme.
    return () => restore.reverse().forEach((reset) => reset());
  }, [isDark]);
}
